import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {Color} from "../Color";
import LockCompetitor from "../../Button/LockCompetitor";
import {Change} from "../Change";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUpDownLeftRight} from "@fortawesome/free-solid-svg-icons";

const FirstCompetitor = ({   vehicle,
                            activeLocale,
                            t,
                            currencyConverter,
                            isLocked,
                            checkLockStatus,
                            removeVehicle,
                            changeHandler,
                            handleToggle,
                            handleChangeModalClose,
                            vehicleData,
                            setVehicleData,
                            openModal,
                            setOpenModal,
                            secondaryYear,
                            vehiclesMakes,
                            vehicleModel,
                            trimModel,
                            setTrimModel,
                            setVehicleModel,
                            setVehicleMake,
                            vehiclesTrim,
                            vehicleIndex,
                            vehicleTypeName,
                            driveType,
                            setDriveType,
                            getCompetitorImages,
                            trimCodes
                        }) => {
    return(<>
        <div >
            {
                vehicle ?
                    <div className="competitor-vehicle-overview">
                        <div className={"action-buttons"}>
                            <button
                                type="button"
                                className="move-icon">
                                <FontAwesomeIcon icon={faUpDownLeftRight} />
                            </button>
                            <button
                                type="button"
                                className={"close-compare"}
                                id={"features-vehicle-remove"}
                                onClick={() => removeVehicle(vehicle, 1)}
                                disabled={isLocked && checkLockStatus(vehicle, isLocked,1)}
                            >
                                <CloseIcon fontSize={"medium"}/>
                            </button>
                        </div>
                        {vehicle &&
                        getCompetitorImages(vehicle, activeLocale)}

                        <div className={"vehicle-detail"}>
                            <div className={"competitor-vehicle-yearMake"}>
                                {vehicle?.year} {vehicle?.make}
                            </div>
                            <div className={"competitor-vehicle-yearMake"}>
                                {vehicle?.model} {vehicle?.trim}
                            </div>
                            <div className={"price-start"}>
                                {vehicle &&
                                <span>{t('overview.startingFrom')} </span>}

                                {vehicle &&
                                <span> {currencyConverter(vehicle?.pricing.msrp, activeLocale)}*</span>}
                            </div>
                        </div>
                    </div> :
                    <div className="competitor-vehicle-overview">
                        <div className="no-vehicle">{t('overview.noVehicleSelected')}</div>
                    </div>
            }
            <div className={"secondary-feature-controller"}>
                {vehicle && <div className={"color-box-controller"}
                                 style={{
                                     left: '-10px'
                                 }}
                >
                    <Color
                        primaryColor={
                            vehicle?.colors?.exteriors
                        }
                        translate={t}
                        mediaColor={vehicle?.currentColor}
                        id={0}
                        interiorColor={vehicle?.colors?.interiors}
                    />
                </div>}
                <div className={"secondaryvehicleController"}>
                    <button
                        id={1}
                        className={isLocked && checkLockStatus(vehicle, isLocked,1) ? "btn-default btn-change-disabled" :"btn-default btn-change-compare"}
                        value={vehicle}
                        onClick={(event) => changeHandler(1, vehicle)}
                        disabled={isLocked && isLocked[1]}
                        title={checkLockStatus(vehicle, isLocked,1)? t("overview.changeSelectModal.vehicleLocked") : null}
                    >
                        {vehicle  ?
                            t('overview.changeSelectModal.change') :  t('overview.controls.selectVehicle')}
                    </button>

                    <LockCompetitor isLocked={isLocked}
                                    vehicle={vehicle}
                                    vehicleIndex = {1}
                                    trimCodes={trimCodes}
                                    toggleLock={() =>handleToggle(1,vehicle)} />

                    <Change vehicleData={vehicleData}
                            setVehicleData={setVehicleData}
                            openModal={openModal}
                            setOpenModal={setOpenModal}
                            handleModalClose={handleChangeModalClose}
                            years={secondaryYear}
                            vehicleMake={vehiclesMakes}
                            vehicleModels={vehicleModel}
                            trimModel={trimModel}
                            setTrimModel={setTrimModel}
                            setVehicleModel={setVehicleModel}
                            setVehicleMake={setVehicleMake}
                            vehiclesTrim={vehiclesTrim}
                            vehicleIndex={vehicleIndex}
                            vehicleTypeName = {vehicleTypeName}
                            driveType={driveType}
                            setDriveType={setDriveType}
                            lockedVehicle={isLocked}
                    />
                </div>
            </div>
        </div>
    </>)
}

export default FirstCompetitor;